import { render, staticRenderFns } from "./OtherMenuComponent.vue?vue&type=template&id=060756b2&scoped=true&"
import script from "./OtherMenuComponent.vue?vue&type=script&lang=js&"
export * from "./OtherMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./OtherMenuComponent.vue?vue&type=style&index=0&id=060756b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060756b2",
  null
  
)

export default component.exports